import React from 'react';
import { AddAccommodations as AddAccommodationsList } from './AddAccommodations';
import { AddAccommodationsProps } from './AddAccommodations.types';
import { AdminAccommodationsTelemetryProvider } from '../../Accommodations.telemetry';

export const AddAccommodations: React.FC<AddAccommodationsProps> = props => {
  return (
    <AdminAccommodationsTelemetryProvider>
      <AddAccommodationsList {...props} />
    </AdminAccommodationsTelemetryProvider>
  );
};
